import React from "react";

import Facebook from "./_tracking/facebook";
import Getklar from "./_tracking/getklar";
import GTM from "./_tracking/gtm";
import Kameeleon from "./_tracking/kameeleon";
import Klaviyo from "./_tracking/klaviyo";
import Pinterest from "./_tracking/pinterest";
import ShopifyAnalytics from "./_tracking/shopifyAnalytics";
import SkimLinks from "./_tracking/skimLinks";
import Tiktok from "./_tracking/tiktok";

const Tracking: React.FC = () => {
  return (
    <>
      <GTM />
      <Facebook />
      <Tiktok />
      <Kameeleon />
      <Pinterest />
      <Klaviyo />
      <Getklar />
      <SkimLinks />
      <ShopifyAnalytics />
    </>
  );
};

export default Tracking;
